import backgroundSwirlLight from '../assets/ODP_BG_Light.svg';
import backgroundSwirlDark from '../assets/ODP_BG_Dark.svg';

const MAX_SIZE = '868px';

export const swirlBackgroundStyles = (
  mode: 'light' | 'dark',
  maxSize = MAX_SIZE,
) => ({
  backgroundImage: `url(${mode === 'dark' ? backgroundSwirlDark : backgroundSwirlLight})`,
  backgroundSize: `min(60%, ${maxSize ?? MAX_SIZE}) auto`,
  backgroundPosition: 'top right',
  backgroundRepeat: 'no-repeat',
});
